<template>
    <div v-if="prismicPage">
        <BodyRenderer :slices="prismicPage.body" :page-type="toPascalCase(prismicPage.type)" />
    </div>
</template>

<script setup lang="ts">
import BodyRenderer from '@/components/prismic/BodyRenderer.vue';
import { toPascalCase } from '@/components/prismic/SliceRegistry';
import { joostElementComponentsKey, type JoostElementComponents } from '@/composables/product-page/joostElements';
import { joostElementComponents } from '@/pages/product-page/partials/product-prismic/joostElementComponents';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { useProductStore } from '@/stores/products/ProductStore';
import _ from 'lodash';
import { computed, provide } from 'vue';

defineProps<{
    prismicPage: Record<string, any> | null;
}>();

const productPageStore = useProductPageStore();
const productStore = useProductStore();

// Providing the map from here keeps the product page partials out of the SliceRegistry chunk.
// A withheld element renders nothing: reviews with nothing to show, and the slider/table the magento group switched off.
const availableJoostElements = computed((): JoostElementComponents => {
    const configurableProduct = productPageStore.configurableProduct;

    const withheld = _.compact([
        productPageStore.hasReviews ? undefined : 'LipscoreReviews',
        configurableProduct.same_print_slider_enabled ? undefined : 'SamePrintSlider',
        // A set or meerluik has one price of its own, so the per-size table would only contradict it.
        configurableProduct.price_table_hidden || productStore.isSetBackedProduct ? 'PriceTable' : undefined,
    ]);

    return _.omit(joostElementComponents, withheld);
});

provide(joostElementComponentsKey, availableJoostElements);
</script>
